var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container-fluid"},[_c('principal-navbar',{staticClass:"row"})],1),_c('principal-price',{attrs:{"type":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }